module.exports = __webpack_public_path__ + "img/08.7561e06c.png";